import React, { useState } from 'react';
import ProgressStepper from './ProgressStepper';
import UserDetailsStep from './UserDetailsStep';
import AgencyDetailsStep from './AgencyDetailsStep';
import ReviewStep from './ReviewStep';
import type { UserRegistrationDetails, AgencyRegistrationDetails } from '../../../types/Registration';
import CheckEmailStep from './CheckEmailStep';


const MultiStepSignup: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);

  // Form data state
  const [userDetails, setUserDetails] = useState<UserRegistrationDetails>({
    // Core Identity
    surname: '',
    fullNames: '',
    nickname: '',
    email: '',
    password: '',
    confirmPassword: '',
    idNumber: '',
    identificationType: 'RSA ID',
    dateOfBirth: '',
    gender: 'Male',

    // Contact
    mobileNumber: '',
    homeTelephone: '',

    // Physical Address
    unitNumber: '',
    complex: '',
    streetNumber: '',
    streetName: '',
    suburb: '',
    city: '',
    postalCode: '',

    // Postal Address
    postalAddressSameAsResidential: true,
    postalUnitNumber: '',
    postalComplex: '',
    postalStreetNumber: '',
    postalStreetName: '',
    postalSuburb: '',
    postalCity: '',
    postalPostalCode: '',

    // Legal Agreements
    agreedTerms: false,
    agreedPOPIA: false,
  });

  const [agencyDetails, setAgencyDetails] = useState<AgencyRegistrationDetails>({
    companyName: '',
    tradingAsName: '',
    companyRegistrationNumber: '',
    unitNumber: '',
    complexName: '',
    streetNumber: '',
    streetName: '',
    suburbName: '',
    city: '',
    postalCode: ''
  });

  // Step configuration
  const steps = [
    { id: 1, title: 'User Details', description: 'Personal information' },
    { id: 2, title: 'Agency Details', description: 'Company information' },
    { id: 3, title: 'Review', description: 'Review Information' },
    { id: 4, title: 'Verify', description: 'Verify Email' }
  ];

  // Navigation functions
  const goToNextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const goToStep = (step: number) => {
    setCurrentStep(step);
  };

  // Render current step
  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <UserDetailsStep
            data={userDetails}
            onUpdate={setUserDetails}
            onNext={goToNextStep}
          />
        );
      case 1:
        return (
          <AgencyDetailsStep
            data={agencyDetails}
            onUpdate={setAgencyDetails}
            onNext={goToNextStep}
            onBack={goToPreviousStep}
          />
        );
      case 2:
        return (
          <ReviewStep
            userDetails={userDetails}
            agencyDetails={agencyDetails}
            onNext={goToNextStep}
            onBack={goToPreviousStep}
            onEdit={goToStep}
            onUpdateUserDetails={setUserDetails}
          />
        );
      case 3:
        return (
          <CheckEmailStep 
            email={userDetails.email} 
          />
        )
      default:
        return null;
    }
  };

  return (
    <div>
      {/* Progress Stepper */}
      <ProgressStepper currentStep={currentStep} steps={steps} />
      {/* Current Step Content */}
      {renderCurrentStep()}
    </div>
  );
};

export default MultiStepSignup;
